module.exports = __webpack_public_path__ + "img/img48.ce033fbc.png";